import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MemberSetting } from '../../../models/member-logs/member-setting';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { MemberDetailsService } from '../../../services/member-details.service';
import { TranslationEnum } from '../../../../assets/i18n/translation-enum';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { getSmsNotificationsEnabled } from '../../../store/selectors/user.selector';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-member-consents',
  templateUrl: './member-consents.component.html',
  styleUrls: ['./member-consents.component.scss'],
})
export class MemberConsentsComponent implements OnInit {
  @Input()
  memberId: string;

  @Input()
  locationId: string;

  @Output()
  updateConsent = new EventEmitter<any>();

  @Input()
  set memberSettings(settings) {
    this.processMemberSettings(settings);
  }

  generalSettings = [
    {
      id: MemberSetting.GdprConsent,
      name: 'Gdpr consent',
      active: true,
      tooltipText: TranslationEnum.Member.TOOLTIP_GDPR,
    },
    {
      id: MemberSetting.BirthdateNotification,
      name: 'Birthday notifications',
      active: true,
      tooltipText: TranslationEnum.Member.TOOLTIP_BIRTHDAY,
    },
    {
      id: MemberSetting.MarketingNotification,
      name: 'Marketing notifications',
      active: true,
      tooltipText: TranslationEnum.Member.TOOLTIP_MARKETING,
    },
    {
      id: MemberSetting.TransactionalNotification,
      name: 'Transactional notifications (expire)',
      active: true,
      tooltipText: TranslationEnum.Member.TOOLTIP_TRANSACTIONS,
    }
  ];

  hasGdprConsent: boolean = true;

  private destroy$ = new Subject<boolean>();

  constructor(
    private memberDetailsService: MemberDetailsService, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.store.select(getSmsNotificationsEnabled)
      .pipe(takeUntil(this.destroy$), filter((isEnabled) => isEnabled))
      .subscribe(() => {
        this.generalSettings.push({
          id: MemberSetting.SmsNotification,
          name: 'SMS notifications',
          active: true,
          tooltipText: TranslationEnum.Member.TOOLTIP_SMS,
        } as any);
      });

    if (!this.memberId) {
      this.updateConsent.emit(this.generalSettings);
    }
  }

  settingToggleChange(active, setting) {
    if (this.memberId) {
      this.memberDetailsService
        .updateMemberSetting(this.memberId, this.locationId, setting.id, active)
        .pipe(
          switchMap(() =>
            this.memberDetailsService.getMemberSettings(
              this.memberId,
              this.locationId
            )
          )
        )
        .subscribe((data) => {
          this.processMemberSettings(data);
        });
    } else {
      if (setting.id === MemberSetting.GdprConsent) {
        this.hasGdprConsent = active;
      }

      this.generalSettings = this.generalSettings.map((item) => {
        if (setting.id === MemberSetting.GdprConsent) {
          return {
            ...item,
            active:
              (item.id === MemberSetting.GdprConsent || item.active) && active,
          };
        }

        return {
          ...item,
          active: item.id === setting.id ? active : item.active,
        };
      });

      this.updateConsent.emit(this.generalSettings);
    }
  }

  disableSetting(setting) {
    return !this.hasGdprConsent && setting.id !== MemberSetting.GdprConsent;
  }

  ngOnDestroy() {
    this.destroy$?.next();
    this.destroy$?.unsubscribe();
  }

  private processMemberSettings(data) {
    this.generalSettings.map((setting) => {
      setting.active = data?.indexOf(setting.id) >= 0;
    });

    this.hasGdprConsent = data?.indexOf(MemberSetting.GdprConsent) >= 0;
  }
}
